/**
 * Phones/tablets: docks the celebration guide tab directly below the "Shop the occasion" tab on the left edge,
 * inside the same sticky track, so both stop at the footer together and slide to a thin strip on scroll.
 * When tapped, the tab on the open panel's edge is placed at exactly the height of the tapped tab.
 */
class SGuideTab extends HTMLElement {
  connectedCallback() {
    if (!this.dataset.bound) {
      this.dataset.bound = '';
      const button = this.querySelector('button');
      if (button) {
        button.addEventListener('click', () => {
          const edge = document.querySelector('#celebration-guide .sb-guide-edge');
          if (!edge) return;
          edge.style.top = `${Math.round(button.getBoundingClientRect().top)}px`;
          edge.style.transform = 'none';
        });
      }
    }
    if (this.dataset.docked !== undefined) return;
    const wrap = document.querySelector('[data-occasion-tab-wrap]');
    const occTab = wrap ? wrap.querySelector('[data-occasion-tab]') : null;
    if (!wrap || !occTab) {
      // No "Shop the occasion" tab on this page: show the guide tab on its own.
      this.dataset.ready = '';
      return;
    }
    this.dataset.docked = '';
    const setHeight = () => this.style.setProperty('--occ-h', `${occTab.offsetHeight}px`);
    setHeight();
    new ResizeObserver(setHeight).observe(occTab);
    wrap.append(this);
  }
}

if (!customElements.get('s-guide-tab')) customElements.define('s-guide-tab', SGuideTab);
